import script from "./AvatarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__